<template>
  <ValidationObserver ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Покупка билетов</p>
      </header>
      <section class="modal-card-body">
        <validation-provider v-if="form.pushka" :rules="{required: true}"
                             v-slot="{ errors, valid }" name="ФИО">
          <b-field
              label="ФИО"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
          >
            <b-input v-model="form.name" type="text" :disabled="loading || (form.pushka && ticketsCart.length > 1)"/>
          </b-field>
        </validation-provider>
        <validation-provider
            rules="required|email"
            v-slot="{ errors, valid }" name="Email">
          <span class="required"> Email</span>
          <b-field
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors">
            <b-input v-model="form.email" type="email" :disabled="loading || (form.pushka && ticketsCart.length > 1)"/>
          </b-field>
        </validation-provider>
        <validation-provider :rules="{phone: true, required: true}"
                             v-if="form.pushka"
                             v-slot="{ errors, valid }" name="Телефон">
          <b-field
              label="Телефон"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors">
            <b-input v-mask3="{mask: ['+7 (999) 999-99-99']}" v-model="form.phone" type="text"
                     :disabled="loading || (form.pushka && ticketsCart.length > 1)"/>
          </b-field>
        </validation-provider>
        <template v-if="eventCard.is_pushka">
          <hr>
          <b-field>
            <b-radio ref="pushka" v-if="eventCard.is_pushka" name="pushka" v-model="payment_type" :disabled="loading"
                     native-value="bank">
              Банковская карта
            </b-radio>
          </b-field>
          <b-field>
            <b-radio ref="pushka" v-if="eventCard.is_pushka" name="pushka" v-model="payment_type" :disabled="loading"
                     native-value="pushka">
              Пушкинская карта
            </b-radio>
          </b-field>
          <p class="help has-text-danger" style="margin-bottom: 1rem;"><span
              v-if="form.pushka && ticketsCart.length > 1">По пушкинской карте можно купить только 1 билет.</span>&nbsp;
          </p>
          <hr>
        </template>
        <b-field>
          <b-checkbox v-model="form.subscribe" :disabled="loading">Подписаться на новости</b-checkbox>
        </b-field>
        <validation-provider name="согласия"
                             rules="required" v-slot="{ errors }">
          <b-field>
            <div class="block">
              <b-checkbox v-model="form.agreement" :disabled="loading" native-value="agreement">
                <span class="required">
                Я понимаю, что для посещения Государственного Кремлевского
                Дворца, необходимо
                распечатать билет на бумажном носителе.
                </span>
              </b-checkbox>
              <p class="help has-text-danger" style="margin-bottom: 1rem;">{{ errors[0] }}</p>
            </div>
          </b-field>
        </validation-provider>
        <validation-provider name="ознакомления"
                             rules="required" v-slot="{ errors }">
          <b-field>
            <div class="block">
              <b-checkbox v-model="form.agreementQR" :disabled="loading" native-value="agreement">
                <span class="required">
                Пуск зрителей по билетам начинается за 1 час 45 минут до начала мероприятия.
                Во избежание очереди на входе – приходите заранее!
                </span>
              </b-checkbox>
              <p class="help has-text-danger">{{ errors[0] }}</p>
            </div>
          </b-field>
        </validation-provider>
        <template v-if="eventCard.has_promo_code">
          <hr/>
          <b-field :type="checkType" label="">
            <b-input v-model="promoCode" placeholder="Промокод" type="text"/>
            <p class="control">
              <b-button @click="checkPromoCode" class="button is-primary">Применить</b-button>
            </p>
          </b-field>
          <p class="">Сумма заказа: <b>{{ cartTotalPrice }} руб.</b></p>
          <p v-if="promoCodeChecked && promoCodeStatus === 1" class="">Итого к оплате:
            <b>{{ cartTotalPrice - discount }}.00 руб.</b></p>
        </template>
<!--        <template v-if="hasCoupons">-->
<!--          <hr/>-->
<!--          <p class="">Покупка подарка возможна после приобретения билета.</p>-->
<!--        </template>-->
      </section>
      <footer class="modal-card-foot">
        <button :disabled="loading" class="button" type="button" @click="close()">Закрыть</button>
        <button id="button-pay" :disabled="(form.pushka && ticketsCart.length > 1 || isAgreementChecked || isAgreementQrChecked || !form.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.email))"
                v-bind:class="[{'is-loading':loading},'button', 'is-primary']" @click="passes(submit)">Оплатить
        </button>
      </footer>
    </div>
  </ValidationObserver>
</template>

<script>
import {ValidationObserver} from "vee-validate";

import {mapGetters, mapState} from 'vuex'
import {metrika} from "../../mixins/metrikaMixin";

export default {
  name: "ModalFormData",
  mixins: [metrika],
  components: {
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      payment_type: 'bank',
      promoCode: null,
      promoCodeStatus: 2,
      promoCodeChecked: false,
      promoCodeDiscount: 0,
      calcType: 2,
      form: {
        promo_code: null,
        email: '',
        phone: null,
        name: null,
        pushka: false,
        subscribe: false,
        agreement: [],
        agreementQR: [],
      },
    }
  },
  computed: {
    isAgreementChecked() {
      return this.form.agreement.length === 0;
    },
    isAgreementQrChecked() {
      return this.form.agreementQR.length === 0;
    },
    checkType() {
      if (this.promoCodeChecked && this.promoCodeStatus === 1) {
        return 'is-success'
      } else if (!this.promoCodeChecked) {
        return 'is-default'
      }
      return 'is-danger'
    },
    ...mapState({
      ticketsCart: state => state.cart.items,
      eventCard: state => state.eventCard,
      hasCoupons: state => state.hasCoupons,
      counters: state => state.counters,
    }),
    ...mapGetters('cart', {
      cartTotalPrice: 'cartTotalPrice',
      // cartCountTickets: 'cartCountTickets'
    }),
    discount() {

      if (this.promoCodeStatus === 1 && this.promoCodeChecked === true) {
        //if(this.calcType === 2){
        return this.cartTotalPrice / 100 * this.promoCodeDiscount
        // }else {
        //   return this.promoCodeDiscount
        // }
      }
      return 0
    }
  },
  watch: {
    payment_type: {
      handler(newVal) {
        this.form.pushka = newVal !== 'bank';
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.setDefaultPromoCode()
      this.$parent.close()
    },
    checkPromoCode() {
      let app = this;
      window.api.checkPromoCode(this.promoCode, this.eventCard.id, this.ticketsCart).then((res) => {
        let data = res.data.data.data
        app.form.promo_code = data.code

        this.promoCodeStatus = data.status
        this.promoCodeChecked = true
        this.promoCodeDiscount = data.value
        this.calcType = data.calc_type

      }).catch(() => {
        this.setDefaultPromoCode()
      })
    },
    setDefaultPromoCode() {
      this.form.promo_code = null
      this.promoCodeStatus = 2
      this.promoCodeChecked = false
      this.promoCodeDiscount = 0
      this.calcType = 2
    },
    showError(error) {
      this.loading = false
      this.$buefy.snackbar.open({
        duration: 5000,
        message: error,
        type: 'is-danger',
        position: 'is-bottom-left',
        queue: false,
      })
    },
    async submit() {
      this.loading = true;
      let error = ''
      const customer = await window.api.createCustomer(
          this.form.email,
          this.form.name,
          this.form.phone,
          this.form.subscribe
      ).then(res => res.data.data).catch((e) => {
        error = e.response.data.message
      })
      if (customer) {
        let order = await window.api.createOrder(customer.id, this.form.pushka).then(res => res.data.data).catch((e) => {
          error = e.response.data.message
        })
        if (order) {
          const addPlaces = await window.api.addPlacesToOrder(order.id, this.ticketsCart.map(i => i.id), this.form.promo_code)
              .then(res => res.data.success)
              .catch((e) => {
                error = e.response.data.message
              })
          if (addPlaces) {
            window.api.payOrder(
                order.id,
                parseFloat(this.cartTotalPrice),
                this.form.pushka,
                this.sendData(this.eventCard.id, 'pay',this.counters),
                this.eventCard.id,
                this.form.promo_code,
                this.counters,
                this.ticketsCart.map(i => i.id)
            ).then(res => {
              window.location.href = res.data.data.formUrl
            }).catch((e) => {
              error = e.response.data.message
            })
          } else if (!error) {
            error = 'Произошла ошибка'
          }
        } else if (!error) {
          error = 'Произошла ошибка'
        }
      } else if (!error) {
        error = 'Произошла ошибка'
      }

      if (error) {
        this.showError(error)
      }
    },
  }
}
</script>

<style scoped>
.required:before {
  content: "*";
  color: red;
}
</style>
